export default __webpack_public_path__ + "ab61dbd5c541e7e217e7ab7c011cae1b.svg";